<template>
  <div class="home mt-2">
    <div class="d-flex flex-wrap justify-content-between align-items-center mb-3">
      <div class="d-flex align-items-center flex-wrap">
        <h2 class="mb-0 mr-3">Billing Sequences</h2>
      </div>

      <div class="d-flex align-items-center flex-wrap mt-2 mt-sm-0">
        <button
          class="btn btn-sm btn-principal mr-2"
          data-toggle="collapse"
          href="#filtroscollapse"
          role="button"
          aria-expanded="false"
          aria-controls="filtroscollapse"
        >
          <i class="bi-filter"></i> Filtros
        </button>
        <button
          class="btn btn-sm btn-principal mr-2"
          @click="getBillingSequencesExcel"
          title="Descargar listado completo"
        >
          <i class="bi-download"></i> Descargar listado completo
        </button>
        <button
          v-if="isAdmin()"
          class="btn btn-sm btn-principal"
          data-toggle="tooltip"
          data-placement="top"
          title="Nueva Billing Sequence"
          @click="showEdit({}, 'add')"
        >
          <i class="bi-plus"></i> Nueva Billing Sequence
        </button>
      </div>
    </div>
    <div class="collapse mb-3" id="filtroscollapse">
      <div class="card card-body bg-light border-0 shadow-sm py-3 px-4">
        <div class="form-row align-items-end">
          <div class="form-group col mb-2">
            <label class="font-weight-bold small text-muted mb-1" for="servicio_select">Por Sequence</label>
            <input type="text" class="form-control" id="servicio_select" v-model="servicio_sel" placeholder="Filtrar por sequence..." @keyup.enter="serviciosBuscar()" aria-label="Servicio" />
          </div>
          <div class="form-group col mb-2">
            <label class="font-weight-bold small text-muted mb-1" for="descripcion_select">Por Descripción</label>
            <input type="text" class="form-control" id="descripcion_select" v-model="descripcion_sel" placeholder="Filtrar por descripción..." @keyup.enter="serviciosBuscar()" aria-label="Descripción" />
          </div>
          <div class="form-group col-auto mb-2">
            <button @click="serviciosBuscar()" class="btn btn-info px-4"><i class="bi-search"></i> Buscar</button>
          </div>
        </div>
      </div>
    </div>
        <div class="alert alert-success" role="alert" v-if="success">{{ success }}</div>
        <div class="alert alert-danger" role="alert" v-if="error">{{ error }}</div>
        <table class="table xtable-responsive table-striped xtable-fixed table-sm" v-if="billingSequencesBusqueda && billingSequencesBusqueda.data.length">
            <thead>
                <tr>
                    <th @click="orderByfield('id_billing_sequence')" class="tablesorter-header" :class="orderClass('id_billing_sequence')" scope="col" width="80">Id</th>
                    <th @click="orderByfield('sequence')" class="tablesorter-header" :class="orderClass('sequence')" scope="col">Secuencia</th>
                    <th @click="orderByfield('descripcion')" class="tablesorter-header" :class="orderClass('descripcion')" scope="col">Descripción</th>
                    <th @click="orderByfield('full_price')" class="tablesorter-header" :class="orderClass('full_price')" scope="col">Precio</th>
                    <th @click="orderByfield('full_price_tax')" class="tablesorter-header" :class="orderClass('full_price_tax')" scope="col">Impuestos</th>
                    <th @click="orderByfield('bill_restriction')" class="tablesorter-header" :class="orderClass('bill_restriction')" scope="col">Restricción</th>
                    <th scope="col" width="110" v-if="isAdmin()"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="servicioItem of billingSequencesBusqueda.data" :key="servicioItem.id_billing_sequence">
                    <th scope="row">{{ servicioItem.id_billing_sequence }}</th>
                    <td>{{ servicioItem.sequence }}</td>
                    <td>{{ servicioItem.descripcion }}</td>
                    <td>{{ servicioItem.full_price }}</td>
                    <td>{{ servicioItem.full_price_tax }}</td>
                    <td>{{ servicioItem.bill_restriction }}</td>
                    <td>
                        <table-actions
                            :item="servicioItem"
                            active-key="activo"
                            @edit="showEdit(servicioItem, 'edit')"
                            @toggle="showEdit(servicioItem, 'toggle')"
                        />
                    </td>
                </tr>
            </tbody>
        </table>
        <Paginador v-if="billingSequencesBusqueda && billingSequencesBusqueda.pages" :pages="billingSequencesBusqueda.pages" @selPage="changePage"></Paginador>
        <empty-state
            :show="Boolean(post && !(billingSequencesBusqueda && billingSequencesBusqueda.data && billingSequencesBusqueda.data.length))"
            message="No se encontraron secuencias de facturación con el criterio seleccionado."
        />
        <div v-if="error">{{ error.message }}</div>
        <!-- Modal -->
        <div v-if="showModal">
            <transition name="modal">
                <div class="modal-mask">
                    <div class="modal-wrapper">
                        <div class="modal-dialog modal-dialog-scrollable"
                            role="document"
                            :class="operation == 'jerarquia' ? 'modal-lg modal-dialog-scrollable' : ''"
                        >
                            <div class="modal-content">
                                <div class="modal-header">
  <h5 v-if="operation == 'toggle'" class="modal-title">
                    <span v-if="editData.activo == 1"> Suspender Billing Sequence</span>
                    <span v-if="editData.activo == 0"> Reactivar Billing Sequence</span>
                  </h5>
                  <h5 v-if="operation == 'edit'" class="modal-title">Editar Billing Sequence
                    {{editData.id_billing_sequence}}
                  </h5>
                                    <h5 v-if="operation == 'add'" class="modal-title">Nueva Billing Sequence</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <form v-if="
                                                operation == 'edit' ||
                                                operation == 'add'"
                                    >
                              
                                        <div class="form-group">
                                            <label>Secuencia</label>
                                            <input class="form-control" name="sequence" placeholder="Ej: 1/2-3 o 1{2}-3" type="text" v-model="editData.sequence" />
                                            <small class="form-text text-muted">Cadena de IDs de billing codes (ej: 1/2-3 o 1{2}-3).</small>
                                        </div>

                                        <div class="form-group">
                                            <label>Descripción</label>
                                            <input class="form-control" name="descripcion" placeholder="Ej: Secuencia Estándar Diaria" type="text" v-model="editData.descripcion" />
                                            <small class="form-text text-muted">Nombre o detalle descriptivo de la secuencia.</small>
                                        </div>

                                        <div class="form-group">
                                            <label>Precio (con Impuestos)</label>
                                            <input class="form-control" name="full_price_tax" placeholder="Ej: 11.80" type="text" v-model="editData.full_price_tax" />
                                            <small class="form-text text-muted">Monto total final con impuestos incluidos (número decimal, ej: 11.80).</small>
                                        </div>

                                        <div class="form-group">
                                            <label>Precio sin Impuestos</label>
                                            <input class="form-control" name="full_price" placeholder="Ej: 10.00" type="text" v-model="editData.full_price" />
                                            <small class="form-text text-muted">Monto base sin impuestos (número decimal, ej: 10.00).</small>
                                        </div>

                                        <div class="form-group">
                                            <label>MinPriceBS</label>
                                            <input class="form-control" name="min_price_bs" placeholder="Ej: 0" type="text" v-model="editData.min_price_bs" />
                                            <small class="form-text text-muted">Precio mínimo aceptado en la secuencia (número decimal o entero, ej: 0).</small>
                                        </div>

                                        <div class="form-group">
                                            <label>Restricciones</label>
                                            <input class="form-control" name="bill_restriction" placeholder="Ej: 1:1 o 2:1" type="text" v-model="editData.bill_restriction" />
                                            <small class="form-text text-muted">Regla de facturación en formato Intentos:Días (ej: 1:1, 2:1).</small>
                                        </div>
                                        <div class="form-group">
                                            <label>Frecuencia</label>
                                            <input class="form-control" name="frecuency" placeholder="Ej: 1" type="text" v-model="editData.frecuency" />
                                            <small class="form-text text-muted">Frecuencia o periodicidad de reintento en días (número entero, ej: 1).</small>
                                        </div>
                                        <div class="form-group">
                                            <label>Lifetime</label>
                                            <input class="form-control" name="lifetime" placeholder="Ej: 30" type="text" v-model="editData.lifetime" />
                                            <small class="form-text text-muted">Tiempo de vida de la secuencia en días (número entero, ej: 30).</small>
                                        </div>








                                        <div v-if="errors" class="alert alert-danger" role="alert">
                                            <div v-if="typeof errors === 'string'">{{ errors }}</div>
                                            <div v-else>
                                                <div class="font-weight-bold mb-1">Por favor corrija los siguientes campos:</div>
                                                <ul class="mb-0 pl-3">
                                                    <li v-for="(err, field) in errors" :key="field">
                                                        <strong>{{ formatFieldName(field) }}:</strong> {{ formatErrorRule(field, err) }}
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </form>
                                    
                  <p v-if="operation == 'toggle'">
                    Esta seguto de realizár esta acción?
                  </p>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-secondary" @click="closeModal">
                                        <span v-if="operation == 'jerarquia'">Cerrar</span>
                                        <span v-else>Cancelar</span>
                                    </button>
 <button
                    type="button"
                    v-if="operation == 'toggle'"
                    @click="toggleStatus"
                    class="btn btn-primary"
                  >
                    <span v-if="editData.activo == 1"> Suspender</span>
                    <span v-if="editData.activo == 0"> Reactivar</span>
                  </button>                                    <button type="button" v-if="operation == 'edit'" @click="editServicio" class="btn btn-primary">Guardar</button>
                                    <button type="button" v-if="operation == 'add'" @click="agregarServicio" class="btn btn-primary">Guardar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>

</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import Swal from "sweetalert2/dist/sweetalert2.js";
import Paginador from "./Paginador.vue";
import TableActions from "./utiles/TableActions.vue";
import EmptyState from "./utiles/EmptyState.vue";
import { tableSortMixin } from "@/mixins/tableSortMixin";
import { startAsyncExport } from "@/utils/exportHelper";

export default {
  name: "BillingSequeces",
  mixins: [tableSortMixin],

  data() {
    return {
      success: null,
      error: null,
      billingsequences: null,
      descripcion_sel: null,
      id_integrador_sel: localStorage.getItem('integrador'),
      servicio_sel: null,
      billingSequencesBusqueda: null,
      post: false,
      showModal: false,
      editData: null,
      operation: null,
      page: 1,
      errors: [],
      pages: null
    };
  },

  components: {
    Paginador,
    TableActions,
    EmptyState,
  },

  created() {
    this.orderByField = 'id_billing_sequence';
    this.getBillingSequencesBusqueda();
  },

  computed: {
    ...mapGetters("auth", ["user"])
  },

  methods: {
    serviciosBuscar: function() {
      this.changePage(1);
    },

    changePage: function(page) {
      this.page = page;
      this.getBillingSequencesBusqueda(false);
    },

    orderByfield: function(field) {
      this.toggleOrder(field);
      this.getBillingSequencesBusqueda(false);
    },

    getBillingSequencesBusqueda: function(hideResult = true) {
      if (hideResult) this.billingSequencesBusqueda = null;
      this.post = false;
      this.$store.commit("setLoading", true);
      axios
        .post(process.env.VUE_APP_API_URL + "billingsequence/busqueda", {
          page: this.page,
          id_integrador: this.id_integrador_sel,
          sequence: this.servicio_sel,
          descripcion: this.descripcion_sel,
          order_by: { field: this.orderByField, order: this.orderByDirection }
        })
        .then(response => {
          this.billingSequencesBusqueda = response.data;
        })
        .catch(e => {
         this.errors.push(e);
          if (e.response.status==429) {
          Swal.fire({
            title: "Error!",
            text: "Espere un momento y vuelva a intentarlo.",
            icon: "error",
            confirmButtonText: "Aceptar",
          });
          }else{
          Swal.fire({
            title: "Error!",
            text: "Ha ocurrido un error al buscar las servicios",
            icon: "error",
            confirmButtonText: "Aceptar"
          });}
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          this.post = true;
        });
    },
       isAdmin() {
      return this.user && this.user.rol == "admin";
    },  

    deleteServicio: function() {
      this.errors = null;
      this.$store.commit("setLoading", true);
      axios
        .post(process.env.VUE_APP_API_URL + "billingsequence/delete", {
          id_billing_sequence: this.editData.id_billing_sequence
        })
        .then(response => {
          if (
            response &&
            response.data &&
            response.data.errno &&
            response.data.errno > 0
          ) {
            this.errors = response.data.error;
          } else {
            this.showModal = false;
            this.operation = null;
            this.editData = null;
          }
        })
        .catch(e => {
          if (e.response && e.response.data && e.response.data.error) {
            this.errors = e.response.data.error;
          } else {
            Swal.fire({
              title: "Error!",
              text: "Ha ocurrido un error al intentar eliminar",
              icon: "error",
              confirmButtonText: "Aceptar"
            });
          }
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          if (this.operation == null) this.getBillingSequencesBusqueda();
        });
    },

    editServicio: function() {
      this.errors = null;
      this.$store.commit("setLoading", true);

      axios
        .post(process.env.VUE_APP_API_URL + "billingsequence/update", this.editData)
        .then(response => {
          if (
            response &&
            response.data &&
            response.data.errno &&
            response.data.errno > 0
          ) {
            this.errors = response.data.error;
         } else {
            Swal.fire({
              title: "Bien!",
              text: "Billing Sequence actualizada correctamente",
              icon: "success",
              confirmButtonText: "Aceptar",
            });
            
            this.showModal = false;
            this.operation = null;
            this.editData = null;
          }
        })
        .catch(e => {
          if (e.response && e.response.data) {
            if (e.response.data.errors && Object.keys(e.response.data.errors).length > 0) {
              this.errors = e.response.data.errors;
            } else if (e.response.data.error) {
              this.errors = e.response.data.error;
            } else {
              this.errors = "Ha ocurrido un error al intentar guardar";
            }
          } else {
            Swal.fire({
              title: "Error!",
              text: "Ha ocurrido un error al intentar guardar",
              icon: "error",
              confirmButtonText: "Aceptar"
            });
          }
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          if (this.operation == null) this.getBillingSequencesBusqueda();
        });
    },

    showEdit: function(item, operation) {
      this.errors = null;
      this.editData = Object.assign({}, item);
      this.showModal = true;
      this.operation = operation;
      if (this.operation == 'add') {
        this.editData = {
          sequence: "",
          descripcion: "",
          full_price: "",
          full_price_tax: "",
          min_price_bs: "0",
          bill_restriction: "1:1",
          frecuency: "",
          lifetime: "",
          activo: 1,
        };
      }
    },
toggleStatus: function () {
      this.errors = null;
      this.$store.commit("setLoading", true);
      this.editData.activo = 1 - this.editData.activo;
      axios
        .post(process.env.VUE_APP_API_URL + "billingsequence/update", this.editData)
        .then((response) => {
          if (
            response &&
            response.data &&
            response.data.errno &&
            response.data.errno > 0
          ) {
            this.errors = response.data.error;
          } else {
            Swal.fire({
              title: "Bien!",
              text: "BillingSequens actualizada correctamente",
              icon: "success",
              confirmButtonText: "Aceptar",
            });
            this.showModal = false;
            this.operation = null;
            this.editData = null;
          }
        })
        .catch((e) => {
          if (e.response && e.response.data && e.response.data.error) {
            this.errors = e.response.data.error;
          } else {
            Swal.fire({
              title: "Error!",
              text: "Ha ocurrido un error al intentar guardar",
              icon: "error",
              confirmButtonText: "Aceptar",
            });
          }
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          if (this.operation == null) this.getBillingSequencesBusqueda();
        });
    },



  getBillingSequencesExcel: function () {
    startAsyncExport("billingsequence", {
      id_integrador: this.id_integrador_sel,
      order_by: {
        field: this.orderByField,
        order: this.orderByDirection,
      },
    }, "BillingSequences");
  },

    agregarServicio: function() {
      this.errors = null;
      this.editData.id_integrador = this.id_integrador_sel;
      this.editData.activo= 1;
      this.$store.commit("setLoading", true);
      axios
        .post(process.env.VUE_APP_API_URL + "billingsequence/new", this.editData)
        .then(response => {
          if (
            response &&
            response.data &&
            response.data.errno &&
            response.data.errno > 0
          ) {
            this.errors = response.data.error;
          } else {
            Swal.fire({
              title: "Bien!",
              text: "Billing Sequence creada correctamente",
              icon: "success",
              confirmButtonText: "Aceptar",
            });
            this.showModal = false;
            this.operation = null;
            this.editData = null;
          }
        })
        .catch(e => {
          if (e.response && e.response.data) {
            if (e.response.data.errors && Object.keys(e.response.data.errors).length > 0) {
              this.errors = e.response.data.errors;
            } else if (e.response.data.error) {
              this.errors = e.response.data.error;
            } else {
              this.errors = "Ha ocurrido un error al intentar guardar";
            }
          } else {
            Swal.fire({
              title: "Error!",
              text: "Ha ocurrido un error al intentar guardar",
              icon: "error",
              confirmButtonText: "Aceptar"
            });
          }
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          if (this.operation == null) this.getBillingSequencesBusqueda();
        });
    },

    closeModal() {
      this.showModal = false;
      this.operation = null;
    },

    formatFieldName(field) {
      const fieldNames = {
        id_integrador: "Integrador",
        sequence: "Secuencia",
        descripcion: "Descripción",
        full_price: "Precio sin Impuestos",
        full_price_tax: "Precio (con Impuestos)",
        min_price_bs: "MinPriceBS",
        lifetime: "Lifetime",
        frecuency: "Frecuencia",
        bill_restriction: "Restricciones",
        activo: "Estado"
      };
      return fieldNames[field] || field;
    },

    formatErrorRule(field, err) {
      const errList = Array.isArray(err) ? err : [err];
      const messages = errList.map(rule => {
        if (rule === "required") return "Campo obligatorio";
        if (rule === "regex") {
          if (field === "bill_restriction") return "Formato inválido. Debe ser X:Y (ej: 1:1)";
          if (field === "sequence") return "Formato inválido. Debe ser N o N/N-N (ej: 1/2-3)";
          if (field === "full_price" || field === "full_price_tax" || field === "min_price_bs") return "Debe ser un valor numérico decimal (ej: 10.00)";
          return "Formato no válido";
        }
        if (rule === "integer") return "Debe ser un número entero";
        if (rule === "number") return "Debe ser un valor numérico";
        return rule;
      });
      return messages.join(", ");
    }
  }
};
</script>

<style scoped></style>
